// Request will be proxied via /api/be/[...apiGateway].ts
const baseUrl = "/api/be";

export const BackendApiUrl = {
    test: baseUrl + "/api/test",

    //Dashboard
    getCustomerStatusGraph: baseUrl + "/api/v1/dashboard/customer-graph",

    // Customer Management
    customerManagement: baseUrl + "/api/v1/customer",

    expiredDateInfo: baseUrl + "/api/v1/licenses/expiration-date",

    //User Management
    getUser: baseUrl + "/api/User",
    updateUser: baseUrl + "/api/User",

    // Licenses
    getLicenses: baseUrl + "/api/v1/licenses",
    getProductLicenseList: baseUrl + "/api/v1/licenses/product-license",
    issueNewLicense: baseUrl + "/api/v1/licenses/issue-new-license",
    renewLicense: baseUrl + "/api/v1/licenses/renew-license",
    revokeLicense: baseUrl + "/api/v1/licenses/revoke-license",
    getReminderList: baseUrl + "/api/v1/licenses/reminder-list",
    getHistoryReminderList: baseUrl + "/api/v1/licenses/reminder-history",
    reminderNotification: baseUrl + "/api/v1/licenses/send-reminder-notification",
    expiredNotification: baseUrl + "/api/v1/licenses/send-expired-notification",
    getLicenseHistories: baseUrl + "/api/v1/licenses/histories",

    //Products
    getProductList: baseUrl + "/api/v1/products",
};

// functions

// Customer

export function GetCustomerList(
    name: string | undefined,
    isActive: boolean | undefined,
    picName: string | undefined,
    salesName: string | undefined,
    active: number | undefined,
    revoked: number | undefined,
    expired: number | undefined,
    itemsPerPage: number | undefined,
    page: number | undefined
) {
    const param = new URLSearchParams();
    if (name !== undefined) {
        param.append("name", name.toString());
    }
    if (isActive !== undefined) {
        param.append("isActive", isActive.toString());
    }
    if (picName !== undefined) {
        param.append("picName", picName.toString());
    }
    if (salesName !== undefined) {
        param.append("salesName", salesName.toString());
    }
    if (active !== undefined) {
        param.append("active", active.toString());
    }
    if (revoked !== undefined) {
        param.append("revoked", revoked.toString());
    }
    if (expired !== undefined) {
        param.append("expired", expired.toString());
    }
    if (itemsPerPage !== undefined) {
        param.append("itemsPerPage", itemsPerPage.toLocaleString());
    }
    if (page !== undefined) {
        param.append("page", page.toLocaleString());
    }

    return BackendApiUrl.customerManagement + "?" + param.toString();
}

// License

export function GetLicenseList(
    name: string | undefined,
    isActive: boolean | undefined,
    picName: string | undefined,
    salesName: string | undefined,
    active: number | undefined,
    revoked: number | undefined,
    expired: number | undefined,
    itemsPerPage: number | undefined,
    page: number | undefined
) {
    const param = new URLSearchParams();
    if (name !== undefined) {
        param.append("name", name.toString());
    }
    if (isActive !== undefined) {
        param.append("isActive", isActive.toString());
    }
    if (picName !== undefined) {
        param.append("picName", picName.toString());
    }
    if (salesName !== undefined) {
        param.append("salesName", salesName.toString());
    }
    if (active !== undefined) {
        param.append("active", active.toString());
    }
    if (revoked !== undefined) {
        param.append("revoked", revoked.toString());
    }
    if (expired !== undefined) {
        param.append("expired", expired.toString());
    }
    if (itemsPerPage !== undefined) {
        param.append("itemsPerPage", itemsPerPage.toLocaleString());
    }
    if (page !== undefined) {
        param.append("page", page.toLocaleString());
    }

    return BackendApiUrl.customerManagement + "?" + param.toString();
}

export function GetLicenseReminderList(
    pageSize: number | undefined,
    pageNumber: number | undefined,
    customerName: string | undefined,
    status: boolean | undefined,
    issueDate: Date | undefined,
    expiryDate: Date | undefined,
    sendDate: Date | undefined,
    type: string
) {
    const param = new URLSearchParams();

    if (pageSize) {
        param.append("pageSize", pageSize.toString());
    }
    if (pageNumber) {
        param.append("pageNumber", pageNumber.toString());
    }
    if (customerName) {
        param.append("customerName", customerName);
    }
    if (status !== undefined) {
        param.append("status", status ? "true" : "false");
    }
    if (issueDate) {
        param.append("issueDate", issueDate.toISOString());
    }
    if (expiryDate) {
        param.append("expiryDate", expiryDate.toISOString());
    }
    if (sendDate) {
        param.append("sendDate", sendDate.toISOString());
    }
    if (type !== undefined) {
        param.append("type", type);
    }

    return BackendApiUrl.getReminderList + "?" + param.toString();
}

export function GetUserListUrl(
    username: string | undefined,
    email: string | undefined,
    itemsPerPage: number | undefined,
    page: number | undefined
) {
    const param = new URLSearchParams();
    if (username) {
        param.append("username", username.toString());
    }
    if (email) {
        param.append("email", email.toString());
    }
    if (itemsPerPage !== undefined) {
        param.append("itemsPerPage", itemsPerPage.toLocaleString());
    }
    if (page !== undefined) {
        param.append("page", page.toLocaleString());
    }
    return BackendApiUrl.getUser + "?" + param.toString();
}
